<template>
	<div class="c-modal-board-delete-confirmation">
		<Modal v-model="options.active" @input="closeModal" :closable="true">
			<template v-slot:title>
				<svg
					width="24"
					height="24"
					viewBox="0 0 24 24"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<path
						d="M5 6H19M7 3H17M5 21H19C20.1046 21 21 20.1046 21 19V11C21 9.89543 20.1046 9 19 9H5C3.89543 9 3 9.89543 3 11V19C3 20.1046 3.89543 21 5 21Z"
						stroke="currentColor"
						stroke-linecap="round"
						stroke-width="1.5"
					/>
				</svg>

				<h3>Delete this board?</h3>
			</template>
			<template>
				<p>
					This won't delete ads inside the board. They will still be available
					inside your library.
				</p>
				<button
					:disabled="processing === true"
					class="btn btn-primary"
					@click="onDeleteBoard"
				>
					Yes, delete board
				</button>
			</template>
		</Modal>
	</div>
</template>

<script>
import Modal from './index.vue';

export default {
	components: {
		Modal,
	},

	data: function () {
		return {
			options: {
				name: 'modal-board-delete-confirmation',
				active: false,
			},
			forceRender: true,

			processing: false,
		};
	},

	props: {
		selection: {},
	},

	watch: {
		'options.active': {
			handler: function () {},
		},
		deleteConfirmationId: function () {
			if (this.deleteConfirmationId) {
				this.options.active = true;
			} else {
				this.options.active = false;
			}
		},
		board: function () {
			this.forceRender = false;
			this.$nextTick(() => {
				this.forceRender = true;
			});
		},
	},

	computed: {
		deleteConfirmationId: function () {
			return this.$store.getters['boards/deleteConfirmationId'];
		},
		board: function () {
			if (!this.deleteConfirmationId) {
				return;
			}
			let boards = this.$store.getters['boards/filtered'];

			let board = null;

			for (let i = 0; i < boards.length; i++) {
				const f = boards[i];
				if (f.id === this.deleteConfirmationId) {
					board = f;
					break;
				}
			}

			return board;
		},
	},

	methods: {
		onSubmit: function () {},
		activate: function () {
			this.options.active = true;
		},
		closeModal: function () {
			this.$store.dispatch('boards/setDeleteConfirmationId', null);
			//this.options.active = false;
		},
		afterDelete: function () {
			this.closeModal();
		},
		async onDeleteBoard() {
			const board = this.board;
			this.closeModal();
			this.processing = true;
			await this.$store.dispatch('message/sendMessage', {
				message: 'Deleting board',
				timer: 1500,
			});
			const condition = await this.$store.dispatch('boards/remove', board.id);
			if (condition) {
				await this.$store.dispatch('message/sendMessage', {
					message: 'Board deleted',
					timer: 2000,
					status: 'success',
				});
			} else {
				await this.$store.dispatch('message/sendMessage', {
					message: `Couldn't delete board, please try again`,
					timer: 2000,
				});
			}
			this.processing = false;
		},
	},

	mounted: function () {},
};
</script>

<style lang="scss">
.c-modal-board-delete-confirmation {
	.vfm__overlay {
		&.non-closable {
		}
	}
	.modal-container {
		display: flex;
		justify-content: center;
		align-items: center;
		height: 100%;
		overflow-y: auto;
		padding: 0;
	}

	.modal-content {
	}

	.form-edit-boards {
		align-self: baseline;
	}

	.modal-content {
		overflow: hidden;
	}

	.modal {
		&__title {
			display: flex;
			align-items: center;
			padding: 16px var(--spacer);
			background-color: var(--color-bg-2);
			border-bottom: var(--color-bg-4) solid 1px;

			svg {
				width: 32px;
				height: 32px;
				margin-right: var(--margin-lg);
			}

			h3 {
				margin-bottom: 0;
			}
		}

		&__content {
			padding-top: var(--spacer-sm);
			padding-bottom: var(--spacer-sm);
			background-color: var(--color-bg-1);
		}

		&__footer {
			padding: 16px var(--spacer);
			background-color: var(--color-bg-2);
			border-top: var(--color-bg-4) solid 1px;
		}
	}
}
</style>
